import ConfirmationMessage from "Components/CommonComponents/ConfirmationMessage";
import Typography from "Components/CommonComponents/Typography";
import { ToastContextDispatch } from "Context/CommonContext";
import { format, setHours, setMinutes, setSeconds, subDays } from "date-fns";
import moment from "moment";
import React, { useContext, useState } from "react";
import { Button, Tooltip } from "reactstrap";
import "./index.css";
import useViewAccess from "Pages/MySchedule/Hooks/useViewAccess";
import { UserRoles } from "utilFunctions/Constants/UserRoles";
const AttendanceCardFooter = (props: any) => {
  const {
    userInfo,
    scheduleData,
    screen,
    absentLength,
    presentLength,
    unmarkedlength,
    onlineLength,
    handleMarkAttendance,
    isLectureSaveEnableForRole,
    isLOPStudentSaveEnable,
  } = props;
  const { isViewOnly } = useViewAccess({
    UserRoleAccess: [UserRoles.academicCounsellor],
  });
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const ToastDispatch = useContext<any>(ToastContextDispatch);

  const [isSuccessSweetAlert, setIsSuccessSweetAlert] =
    useState<boolean>(false);

  const handleClickMarkAttendance = (e: any) => {
    e.preventDefault();
    setIsSuccessSweetAlert(true);
  };

  const dateViewData = moment(scheduleData?.endTime)
    .utcOffset("+05:30")
    .format()
    .split("T")[0];
  const todayDate = moment().utcOffset("+05:30").format().split("T")[0];
  const past7Days = format(
    setSeconds(setMinutes(setHours(subDays(new Date(), 5), 18), 30), 0),
    "yyyy-MM-dd"
  );
  const time = moment(scheduleData?.endTime);

  const now = moment();
  const endTime = moment(scheduleData?.endTime);

  const isWithin2Hours = now.isSameOrBefore(endTime.clone().add(2, "hours"));

  const getTooltipMessage = () => {
    if (userInfo?.fexRole === "Faculty" && !isWithin2Hours) {
      return "Faculty can only mark attendance within 2 hours after class end time.";
    }
    return unmarkedlength != 0
      ? "Mark all students to save attendance"
      : dateViewData != todayDate
      ? "You can't save attendance for past days"
      : !isLOPStudentSaveEnable
      ? "Mark all students to save attendance"
      : !time.isBetween(past7Days, todayDate)
      ? "You can't mark attendance for more than 5 days"
      : "";
  };

  const handleClick = (e: any) => {
    return isLectureSaveEnableForRole
      ? ToastDispatch({
          isOpen: true,
          type: "Error",
          message: getTooltipMessage(),
        })
      : handleClickMarkAttendance(e);
  };

  const returnColor = () => {
    return isLectureSaveEnableForRole ? "aeslDraft" : "aeslPrimary";
  };

  return (
    <>
      {isSuccessSweetAlert && (
        <ConfirmationMessage
          warning={false}
          primaryButtonName="Save Attendance"
          secondaryButtonName="Cancel"
          warningMessage={`Please confirm If you want to mark attendance for ${
            scheduleData?.eventName
              ? scheduleData.eventName
              : scheduleData?.eventType
          }`}
          onCancel={() => setIsSuccessSweetAlert(false)}
          onConfirm={() => {
            setIsSuccessSweetAlert(false);
            handleMarkAttendance();
          }}
          isSuccessSweetAlert={isSuccessSweetAlert}
          message={
            dateViewData == todayDate && userInfo?.fexRole == "Faculty"
              ? "You can only mark attendance within 2 hours after class end time."
              : time.isBetween(past7Days, todayDate)
              ? "Attendance records are official documentation of student presence and must remain accurate. You are about to mark attendance for a past lecture, which may impact system records and will be logged under your user ID. Please proceed only if absolutely necessary"
              : "You can mark or change student attendance till 11:59 P.M. today."
          }
        />
      )}
      <div className="attendanceCardFooter">
        <div className="d-flex flex-row gap-2 align-items-center">
          <Typography variant="h5" color="white">
            {["xs", "sm", "md"].includes(screen) ? "U" : "Unmarked"}:{" "}
            {unmarkedlength} &nbsp;&nbsp;
          </Typography>
          <Typography variant="h5" color="white">
            {["xs", "sm", "md"].includes(screen) ? "P" : "Present"}:{" "}
            {presentLength}&nbsp;&nbsp;
          </Typography>
          <Typography variant="h5" color="white">
            {["xs", "sm", "md"].includes(screen) ? "O" : "Online"}:{" "}
            {onlineLength}&nbsp;&nbsp;
          </Typography>
          <Typography variant="h5" color="white">
            {["xs", "sm", "md"].includes(screen) ? "A" : "Absent"}:{" "}
            {absentLength}&nbsp;
          </Typography>
        </div>
        <div className={["xs", "sm", "md"].includes(screen) ? "pr-1" : "pr-4"}>
          <Button
            id={
              ["xs", "sm", "md"].includes(screen) || !isLectureSaveEnableForRole
                ? ""
                : "Tooltip-student-attendance-button"
            }
            size={["xs", "sm", "md"].includes(screen) ? "sm" : "md"}
            color={returnColor()}
            className="buttonHeight"
            onClick={(e: any) => {
              handleClick(e);
            }}
            disabled={isViewOnly}
          >
            Save Attendance
          </Button>
          {["xs", "sm", "md"].includes(screen) ||
          !isLectureSaveEnableForRole ? null : (
            <Tooltip
              placement={"top"}
              isOpen={tooltipOpen}
              target={"Tooltip-student-attendance-button"}
              toggle={toggle}
            >
              {getTooltipMessage()}
            </Tooltip>
          )}
        </div>
      </div>
    </>
  );
};

export default AttendanceCardFooter;
